export default __webpack_public_path__ + "static/media/blue-lines-right.901421e3.svg";